import React, { useState } from "react";
import LayoutCard from "../../Layout/Layout";
import CompareSvg from "../../../../images/compare-assessment.svg";
import AssessmentCardList from "../Assessment/AssessmentList/index.jsx";
import useOrientationChange from "../../../Utils/useOrientationChange.jsx";

const Assessments = () => {
  const [reload, setReload] = useState(false);
  useOrientationChange();

  return (
    <LayoutCard
      headerIcon={CompareSvg}
      headerText="Compare Assessments"
      assessmentList={true}
      setReload={setReload}
    >
      <AssessmentCardList reload={reload} />
    </LayoutCard>
  );
};

export default Assessments;



// WEBPACK FOOTER //
// ./src/new/Components/Reports/Assessment/Assessment.jsx